import { render } from "./AnimalsHome.vue?vue&type=template&id=6c6e54aa&scoped=true"
import script from "./AnimalsHome.vue?vue&type=script&lang=js"
export * from "./AnimalsHome.vue?vue&type=script&lang=js"

import "./AnimalsHome.vue?vue&type=style&index=0&id=6c6e54aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c6e54aa"]])

export default __exports__